import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { statusAllAlumni } from './redux/reduxApi';

const actions = {
  closeModal,
  statusAllAlumni,
};

function ModalStatus({ data, closeModal, statusAllAlumni }) {
  const { auth, history, items, onClose } = data || {};
  const portalusers = items?.portalusers;
  const studentsUserIds = items?.students?.map((s) => s.userId);
  let status = portalusers.length > 0 ? true : false;

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
    closeModal();
  };

  async function setStatus() {
    if (!items) {
      handleClose();
      return;
    }

    if (!auth || !history) {
      handleClose();
      return;
    }

    await statusAllAlumni({ auth, history, studentsUserIds, status });
    if (typeof onClose === 'function') {
      onClose();
    }
    closeModal();
  }

  return (
    <Modal variant='info' closeModal={handleClose}>
      <p className='my-3 mx-1'>
        Apakah Anda ingin set semua Siswa{' '}
        <span className='has-text-danger has-text-weight-semibold is-capitalized'>
          Kelas {items.kelas} {items.year} - Sem {items.sem}
        </span>{' '}
        menjadi {status ? 'Alumni' : 'Siswa'}? <br/>
        <span className='is-italic has-text-grey' style={{ fontSize: '0.8rem' }}>
          Note: Jika Anda set menjadi Alumni, maka status siswa tidak aktif dan tidak lagi bisa mengakses portal.
        </span>
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={setStatus} />
          <Button cvariant='cback' onClick={handleClose} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalStatus);
